/* eslint-disable no-unused-vars */
import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import './css/RosterThumbnail1.css';
import { NavLink } from 'react-router-dom';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { context } from '../../../../globalState/GlobalState';

const RosterThumbnail1 = (props) => {
    const { season } = props;
    const { globalState } = useContext(context);

    const getImage = () => {
        if (!isValidObject(globalState) || !isValidObject(globalState.websiteImages)) {
            return null;
        }
        let featureImage = null;
        globalState.websiteImages.forEach((image) => {
            if (image.id === 'featureImage1') {
                if (isValidString(image.image)) {
                    featureImage = image.image;
                } else {
                    featureImage = null;
                }
            }
        });

        if (!isValidObject(featureImage)) {
            return null;
        }
        return featureImage;
    };

    return (
        <NavLink to={`/season/${season.id}`}>
            <div className="roster-thumbnail1-container text-left-align curve-border-20px text-black text-no-underline">
                <img className="roster-thumbnail1-image" src={getImage()} alt={isValidString(season.name) ? `Season ${season.name}` : 'Season Title'} />
                <div className="roster-thumbnail1-text-container">
                    <p className="roster-thumbnail1-text font-size-4xl font-weight-800 text-white font-spacing-wider">{season.name}</p>
                </div>
            </div>
        </NavLink>
    );
};

RosterThumbnail1.propTypes = {
    season: PropTypes.object.isRequired,
};

export default memo(RosterThumbnail1);
